/**
 * ImageEmptyValidator class is responsible for validating if an image model is empty.
 * It provides methods to check the validation status and retrieve error messages.
 */
class ImageEmptyValidator {
    /**
     * Constructs an instance of ImageEmptyValidator.
     * @param {Object} model - The model to be validated.
     * @param {Object} $injector - The injector used to get translation services.
     */
    constructor(model, $injector) {
        this.model = model;
        this.$injector = $injector;

        this._translate = null;
        /**
         * Lazily initializes and returns the translation service.
         * @returns {Object} The translation service.
         */
        this.$translate = function () {
            if (!this._translate) {
                this._translate = this.$injector.get('$translate');
            }
            return this._translate;
        }.bind(this);

        this._messageTranslateString = 'CMS.FACTORIES.MODELS.VALIDATORS.EMPTY.IMAGE';
        this._message = null;
        this._forced_check = false;
    }

    /**
     * Validates the model and returns the validation result.
     * @param {string} from - The source from which the validation is triggered.
     * @returns {Object} The validation result.
     */
    validate(from) {
        let isError = this.model.isContentEmpty();

        // If the model is empty and has no parents, it is not considered an error.
        if (isError && this.model.getParents().length === 0) {
            isError = false;
        }

        return {
            'onSheetBlur':      false,
            'onlyBanner':       false,
            'validator':        this.getValidatorName(),
            'modelUUID':        this.model.getUUID(),
            'error':            isError,
            'status':           isError ? 'DANGER' : 'SUCCESS',
            'message':          this.getErrorMessage(),
            'message_template': false,
            'callbacks':        [
                'validationDisplayObjectHeader-' + this.model.getUUID()
            ]
        };
    }

    /**
     * Gets the error message for the validation.
     * @returns {string} The error message.
     */
    getErrorMessage() {
        const questionHeadline = this.model.getQuestionHeadline();
        this._message = this.$translate().instant(this._messageTranslateString, {
            s: questionHeadline ? questionHeadline : ''
        });

        return this._message;
    }

    /**
     * Checks if a forced check is set.
     * @returns {boolean} The status of the forced check.
     */
    forcedCheck() {
        return this._forced_check;
    }

    /**
     * Gets the name of the validator.
     * @returns {string} The name of the validator.
     */
    getValidatorName() {
        return 'ImageEmptyValidator';
    }
}

export default ImageEmptyValidator;